import { useSwrNoAuth } from "../swr/useSwrNoAuth";

type FoodMenu = {
  id: string;
  restaurant: string;
  menu_type: string;
  img: string;
}[]
export const useFetchCustomerChineseFoodMenu = (restaurantId: string) => {
  const { data: foodMenu, error, isLoading } = useSwrNoAuth<FoodMenu>(`menu/restaurants/${restaurantId}/food/chinese/customer/`)
  return { foodMenu, isLoading, error };
};